import { Box, Stack, Typography } from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import React, { Fragment } from "react";
import NumberFormat from "react-number-format";

import { images } from "../../constants";
import { formatProcessingText } from "../../utils/functions/formatProcessingText";

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 4,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#e7e7e7",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 4,
    backgroundColor: "#1278cc",
  },
}));

const SavingItem = ({
  retailFlag,
  savingName,
  savingTarget,
  savingMonthBar,
  image,
  portfolio,
  onClick,
  cashInSts = [],
  currentValue,
}) => {
  const getRoundedValue = (val, digit) => {
    const value = parseFloat(val);
    return Math.round(value * Math.pow(10, digit)) / Math.pow(10, digit);
  };

  const myReduce = data => {
    return data.reduce((acc, curr) => acc + curr.unitHeld * curr.fund.nav, 0);
  };

  const savingMonthPercentage = savingMonthBar
    .toFixed(2)
    .replace(/[.,]00$/, "");

  const savingValue = currentValue
    ? Number(currentValue)
    : Array.isArray(portfolio)
    ? getRoundedValue(myReduce(portfolio), 2)
    : getRoundedValue(portfolio.unitHeld * portfolio.fund.nav, 2);

  const savingMonthLeft = savingValue - savingTarget;

  return (
    <Box
      onClick={onClick}
      sx={{
        margin: "16px",
        padding: "16px",
        backgroundColor: "#fff",
        boxShadow: "0 12px 24px -10px #d8d8d8",
        borderRadius: "4px",
      }}
      data-cy={`saving-goal-${savingName}`}
    >
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <img
          src={image ? image : images.generalSavings}
          alt="dummy"
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "4px",
            objectFit: "cover",
          }}
        />
        <Box
          sx={{ display: "flex", flexDirection: "column", marginLeft: "8px" }}
        >
          <Typography
            color="textPrimary"
            sx={{
              fontWeight: "700",
            }}
          >
            {savingName}
          </Typography>
          <Typography
            sx={{
              marginTop: "4px",
            }}
          >
            <span
              style={{
                fontWeight: "900",
              }}
            >
              {savingValue < 0 && "-"}
              RM{" "}
              <NumberFormat
                value={savingValue > 0 ? savingValue : savingValue * -1}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </span>{" "}
            {!retailFlag && savingTarget > 0 && (
              <>
                <span> / RM </span>
                <NumberFormat
                  value={savingTarget}
                  thousandSeparator
                  displayType="text"
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </>
            )}
          </Typography>
        </Box>
      </Box>
      {!retailFlag && savingMonthLeft !== null && (
        <>
          <Stack
            direction="row"
            spacing={1.5}
            sx={{ flexGrow: 1, marginTop: 2 }}
            useFlexGap={true}
            justifyContent="space-between"
            alignItems="center"
          >
            {/* Bar */}
            <StyledLinearProgress
              variant="determinate"
              value={savingMonthBar ? savingMonthBar : 0}
              sx={{ width: "100%" }}
            />
            <Typography
              color="textPrimary"
              sx={{ fontWeight: "900", fontSize: "14px", lineHeight: 1.57 }}
            >
              {savingMonthPercentage ? savingMonthPercentage : 0}%
            </Typography>
          </Stack>

          <Typography
            sx={{ fontSize: "14px", lineHeight: 1.57, marginTop: "4px" }}
            style={{
              color: savingMonthLeft > 0 ? "#18a29a" : "#616367",
              fontWeight: savingMonthLeft >= 0 && "700",
            }}
          >
            {savingMonthLeft >= 0 ? `Completed` : ``}
            {savingMonthLeft >= 0 && <br />}
            {cashInSts.map((item, index) => (
              <Fragment key={index}>
                <span style={{ color: "#1793D7", fontWeight: "400" }}>
                  {formatProcessingText(item, "save")}
                </span>
                <br />
              </Fragment>
            ))}
          </Typography>
        </>
      )}
      {retailFlag && (
        <Typography
          sx={{
            fontSize: "14px",
            marginTop: "4px",
            lineHeight: 1.57,
          }}
          style={{}}
        >
          {" "}
          {cashInSts.map((item, index) => (
            <Fragment key={index}>
              <span
                style={{
                  color: "#1793D7",
                  fontWeight: "400",
                }}
              >
                {formatProcessingText(item, "save")}
              </span>
              <br />
            </Fragment>
          ))}{" "}
        </Typography>
      )}
    </Box>
  );
};

export default SavingItem;
